<ng-template #operatorView>
  <app-payment-receipts-table></app-payment-receipts-table>
</ng-template>

<ng-template #customerView>
  <app-payment-receipts-table></app-payment-receipts-table>
</ng-template>

<ng-template #userView>
  <app-payment-receipts-table></app-payment-receipts-table>
</ng-template>

<main id="payment-receipts" *ngIf="isOperator">
  <ng-container *ngTemplateOutlet="operatorView"></ng-container>
</main>

<main id="payment-receipts" *ngIf="isCustomer">
  <ng-container *ngTemplateOutlet="customerView"></ng-container>
</main>

<main id="payment-receipts" *ngIf="isUser">
  <ng-container *ngTemplateOutlet="userView"></ng-container>
</main>

<router-outlet (activate)="onRouterOutletActivate($event)"></router-outlet>